<template>
  <div class="common-footer">
    <div class="kere"></div>
    <div class="footer-main">
     
      <div class="logo_copyright">
        <img src="https://staticweb.ewan.cn/resources/img/ddj-tw/footer_logo.png" />
        <div class="footer-btn">
          <a class="medium" href="https://www.facebook.com/happybigboss" target="_blank">聯繫客服</a>
          <a class="medium" href="./regist.html" target="_blank">服務條款</a>
          <a class="medium" href="./privacy.html" target="_blank">隱私政策</a>
          <a class="medium" href="javascript:;">IYA GAMES</a>
        </div>
        <div class="medium copy-right">
          @SINGAPORE JUST GAME TECHNOLOGY PTE. LTD.
        </div>
      </div>
      <div class="footer-right">
        <img src="https://staticweb.ewan.cn/resources/img/ddj-tw/plus12.png" class="level" />
        <p class="medium">
          ※本遊戲內容涉及性、暴力、菸酒、戀愛交友情節，依遊戲軟體分級管理辦法分類為輔導15歲級，15歲以上之人方得使用。
        </p>
        <p class="medium">
          ※本遊戲為免費遊戲，但遊戲內另提供購買虛擬遊戲幣、物品等付費服務，請依個人興趣及能力進行適度消費。
        </p>
        <p class="medium">
          ※請注意遊戲時間，避免沉迷，長時間進行遊戲，容易影響作息，宜適度休息及運動。
        </p>
        <p class="medium">
          本遊戲由艾瑞爾網路股份有限公司代理，如有疑問，請以本遊戲客服管道聯繫。
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  mounted() {},
  beforeCreate() {},
  created() {},
  methods: {
    toService() {
      let routeUrl = this.$router.resolve({
        path: "/terms",
        query: { pageType: "service" },
      });
      window.open(routeUrl.href, "_blank");
    },
    toPrivacy() {
      let routeUrl = this.$router.resolve({
        path: "/terms",
        query: { pageType: "privacy" },
      });
      window.open(routeUrl.href, "_blank");
    },
  },
};
</script>
<style lang="scss" scoped>
@mixin disf {
  display: flex;
  display: -webkit-flex;
}
@mixin disf-center {
  justify-content: center;
  align-items: center;
}

@media screen and (min-width: 769px) {
  .common-footer {
    width: 100%;
    height: 196px;
    background-color: #0c1319;
    position: relative;
    .footer-main {

      margin: 0 auto;
      width: 1220px;
      height: 196px;
      left: 0;
      bottom: 0;
      z-index: 2;
      @include disf;
      @include disf-center;
    }

    .kere{
      position: absolute;
      top: 67px;
      left: 150px;
      width: 502*0.35px;
      height: 177*0.35px;
      background-image: url('../assets/images/kere.png');
      background-size: 100% 100% ;
      
    }
    .logo_copyright {
      position: relative;
      &:after {
        content: "";
        position: absolute;
        width: 1px;
        height: 76px;
        right: 0;
        top: 50%;
        margin-top: -38px;
        background-color: #5e5e5e;
      }
      img {
        width: 220px;
      }
    }
    .medium {
      line-height: 22px;
    }
    .copy-right,
    .footer-btn {
      width: 325px;
      display: block;
      font-size: 10px;
      color: #b5b5b5;
      margin-top: 5px;
      a {
        color: #b5b5b5;
        font-family: "NotoSansCJKsc-Regular";
        text-decoration: none;
        margin-right: 10px;
      }
    }
    .copy-right {
      padding-top: 0;
      margin-top: 0;
    }
    .logo {
      display: block;
      width: 216px;
      margin-bottom: 12px;
      img {
        height: auto;
      }
    }
    .footer-right {
      position: relative;
      display: block;
      width: 900px;
      padding-left: 125px;
      font-size: 11px;
      color: #b5b5b5;
      line-height: 20px;
      .level {
        position: absolute;
        width: 68px;
        height: 72px;
        left: 44px;
        top: 5px;
      }
      p {
        font-size: 12px;
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .common-footer {
    position: relative;
    height: 600px;
    .kere{
      position: absolute;
      top: 27px;
      left: 270px;
      width: 502*0.35px;
      height: 177*0.35px;
      background-image: url('../assets/images/kere.png');
      background-size: 100% 100% ;
      
    }
    .footer-main {
      &.fixed {
        position: fixed;
      }
      width: 100%;
      height: 600px;
      left: 0;
      bottom: 0;
      z-index: 2;
      background-color: #0c1319;
      @include disf;
      flex-direction: column;
      @include disf-center;
    }
    .logo_copyright {
      height: 210px;
      img {
        width: 355px;
        margin: 0 auto 30px;
        display: block;
      }
    }
    .copy-right,
    .footer-btn {
      border-top: 1px solid #494e53;
      width: 620px;
      display: block;
      padding-left: 76px;
      padding-top: 30px;
      font-size: 20px;
      color: #b5b5b5;
      line-height: 20px;
      white-space: nowrap;
      a {
        color: #b5b5b5;
        text-decoration: none;
        margin-right: 10px;
      }
    }
    .copy-right {
      border-top: none;
      padding-top: 0;
      margin-top: 18px;
      white-space: wrap;
    }
    .logo {
      display: block;
      width: 352px;
      height: 68px;
      margin-bottom: 30px;
    }
    .footer-right {
      position: relative;
      width: 620px;
      display: block;
      font-size: 16px;
      color: #b5b5b5;
      line-height: 28px;
      .level {
        position: absolute;
        width: 54px;
        height: 60px;
        left: 0;
        top: -90px;
      }
      p {
        margin-bottom: 4px;
      }
    }
  }
}
</style>
